const createEnvironmentFlags = (development = false, staging = false, production = false) => (
  { development, staging, production }
);

const flags = {
  newRegistryOnboarding: createEnvironmentFlags(true, true, true),
  themeDetailCarousel: createEnvironmentFlags(false, false, false),
  webPreviewRefactor: createEnvironmentFlags(true, false, false),
  mobileCustomization: createEnvironmentFlags(true, true, true),
  updatePDPcopy: createEnvironmentFlags(true, true, false),
  regionStateBug: createEnvironmentFlags(true, true, false),
  preauthNewCardTypes: createEnvironmentFlags(true, true, true),
  enforceAllCapsOnAddressing: createEnvironmentFlags(true, true, true),
  seatingChart: createEnvironmentFlags(true, true, false),
  invitesModalRedirectTest: createEnvironmentFlags(true, true, true),
  refactorMobileRsvp: createEnvironmentFlags(true, true, false),
  dynamicThemeCount: createEnvironmentFlags(true, true, true),
  preauthChecklistCta: createEnvironmentFlags(true, true, true),
  weddingDashboardEditorialWithNoDek: createEnvironmentFlags(true, true, true),
  invitesPLPDraperJames: createEnvironmentFlags(true, true, true),
  invitesPDPCarousel: createEnvironmentFlags(true, true, false),
  invitesPDPCustomizeRedirect: createEnvironmentFlags(true, true, false),
};

const getEnvironment = () => {
  const zolaEnv = window.zola && window.zola.env;
  switch (zolaEnv) {
    case 'development':
    case 'dev':
      return 'development';
    case 'staging':
    case 'stage':
      return 'staging';
    case 'production':
    case 'prod':
      return 'production';
    default:
      return 'production';
  }
};

const get = (flag) => {
  if (flags[flag]) {
    return Boolean(flags[flag][getEnvironment()]);
  }
  return false;
};

export default {
  get
};



// WEBPACK FOOTER //
// ./src/util/featureFlags.js